module.exports = __webpack_public_path__ + "img/pecans-bg-portrait-768w.7b763431.jpg";